var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.12 10.667a17 17 0 0 0 3.058 4.155 17 17 0 0 0 4.155 3.058l2.404-2.404a1 1 0 0 1 .523-.314.9.9 0 0 1 .6.052q1.725.601 3.869.601.444 0 .757.314.315.315.314.758v3.842q0 .444-.314.757-.313.315-.757.314-3.765 0-7.213-1.463a18.5 18.5 0 0 1-5.88-3.973 18.5 18.5 0 0 1-3.973-5.88A18.3 18.3 0 0 1 2.2 3.271q0-.444.314-.757.313-.314.757-.314h3.842q.444 0 .758.314.314.313.314.757 0 2.144.6 3.868.08.288.027.601a.87.87 0 0 1-.288.523z"
})));
export default SvgPhone;